<template>
  <v-container>
    <gridView v-if="edit" @editItem="editItem" />
    <formView v-else :integrationUpdating="integrationName" @editItem="editItem" />
  </v-container>
</template>

<script>
import gridView from './grid'
import formView from './formRestToSoap'

export default {
  name: 'restToSoap',

  data: () => ({
    edit: true,
    integrationName: ''
  }),

  components: {
    gridView,
    formView
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.integrationName = item?.nameMethod
    }
  }
}
</script>
